import * as css from 'css/exports.module.scss';
import './FieldScopeHeader.scss';
import { SonarTagManager } from '@ui/tags';
import { Space } from 'antd';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback, useEffect } from 'react';
import { SonarRecordNameSection, SonarRecordReferences, SonarRecordRelationships } from '@ui/records';
import { usePeriscopeActions, useSonarObjectReference } from '@hooks';
export const FieldScopeHeader = ({ data, index }) => {
    const { isActive, relatedCounts, sonarObjectId, versionNumber } = data;
    const { linkedIntegrations, internalName, parentDisplayName, parentInternalName, parentSonarObjectId, rawSalesforceType } = useSonarObjectReference(sonarObjectId);
    const { openPeriscope, updatePeriscope } = usePeriscopeActions();
    useEffect(() => {
        var _a, _b;
        updatePeriscope({
            periscopeIndex: index,
            subType: (_b = (_a = data.type) !== null && _a !== void 0 ? _a : rawSalesforceType) !== null && _b !== void 0 ? _b : ''
        });
    }, [updatePeriscope, data.type, rawSalesforceType, index]);
    const handleParentClick = useCallback(() => {
        openPeriscope({
            id: parentSonarObjectId !== null && parentSonarObjectId !== void 0 ? parentSonarObjectId : 0,
            name: parentDisplayName !== null && parentDisplayName !== void 0 ? parentDisplayName : '',
            openLeft: true,
            openedFromIndex: index,
            type: SonarObjectType.SalesforceEntity
        });
    }, [openPeriscope, parentSonarObjectId, parentDisplayName, index]);
    return (React.createElement("div", { className: 'field-scope-header' },
        React.createElement(Space, { size: Number(css.size8) },
            React.createElement(SonarRecordNameSection, { isActive: isActive, name: internalName !== null && internalName !== void 0 ? internalName : '', onClickParent: handleParentClick, parentName: parentInternalName !== null && parentInternalName !== void 0 ? parentInternalName : '', removeBold: true, showArrow: true, versionNumber: versionNumber }),
            React.createElement(SonarRecordRelationships, { relatedOrgs: linkedIntegrations })),
        React.createElement("div", { className: 'record-references' },
            React.createElement(SonarRecordReferences, { parentName: parentDisplayName !== null && parentDisplayName !== void 0 ? parentDisplayName : '', relatedCounts: relatedCounts, sonarObjectId: sonarObjectId }),
            React.createElement(SonarTagManager, { sonarObjectId: sonarObjectId }))));
};
